import React from 'react';
import {ComplaintContent} from './sub-view/complaint-content';
import {UserLayout} from 'components/layouts/user';
import {Link} from 'react-router-dom';

class ComplaintContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="my-post-complains">
        <h1 className="complaint-header">Khiếu nại</h1>
        <Link to="/user/complains/post" className="btn-post-complaint">Gửi khiếu nại</Link>
        <ComplaintContent/>
      </UserLayout>
    );
  }
}

export default ComplaintContainer;



// WEBPACK FOOTER //
// ./components/users/ComplaintContainer.jsx